<template>
  <el-row>
    <el-col :span="7">
      <el-select
        v-model="regionInfo.provinceCode"
        filterable
        placeholder="省"
        :disabled="isdisabled"
        @change="selectHandler('province')"
      >
        <el-option
          v-for="item in addressInfo.province"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </el-col>
    <el-col :span="1">
      <div style="height:5px"></div>
    </el-col>
    <el-col :span="7">
      <el-select
        v-model="regionInfo.cityCode"
        filterable
        placeholder="市"
        :disabled="isdisabled"
        @change="selectHandler('city')"
      >
        <el-option
          v-for="item in cityDetail"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </el-col>
    <el-col :span="1">
      <div style="height:5px"></div>
    </el-col>
    <el-col :span="7">
      <el-select
        v-model="regionInfo.countyCode"
        filterable
        placeholder="区"
        :disabled="isdisabled"
      >
        <el-option
          v-for="item in countyDetail"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
import { fetchRegionData } from "@/services/api.index";
export default {
  name: "region-cascade",
  model: {
    event: "change",
    value: "value"
  },
  props: {
    value: {
      type: [Object, String]
    },
    isdisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      regionInfo: {
        province: "",
        city: "",
        county: "",
        provinceCode: "",
        cityCode: "",
        countyCode: ""
      },
      addressInfo: {},
      cityDetail: [],
      countyDetail: []
    };
  },
  created() {
    this.getThreeLevelAddress();
  },
  methods: {
    async getThreeLevelAddress() {
      const { data } = await fetchRegionData();
      this.addressInfo = data;
    },
    selectHandler(type) {
      this.regionInfo.countyCode = "";
      const parentCode = `${type}Code`;
      let num = 4;
      let childType = "county";
      if (type === "province") {
        num = 2;
        childType = "city";
        this.regionInfo.cityCode = "";
      }
      const sameCode = this.regionInfo[parentCode].slice(0, num);
      this[`${childType}Detail`] = this.addressInfo[childType].filter(
        ({ name, code }) => code.slice(0, num) === sameCode
      );
    }
  },
  watch: {
    regionInfo: {
      deep: true,
      handler(newVal) {
        console.log("newVal", newVal);
        this.$emit("change", newVal);
      }
    },
    "regionInfo.countyCode": {
      handler(newVal) {
        this.regionInfo.county = this.countyDetail.find(
          ({ code }) => code === newVal
        )
          ? this.countyDetail.find(({ code }) => code === newVal).name
          : "";
        this.regionInfo.city = this.cityDetail.find(
          ({ code }) => code === this.regionInfo.cityCode
        )
          ? this.cityDetail.find(
              ({ code }) => code === this.regionInfo.cityCode
            ).name
          : "";
        this.regionInfo.province = this.addressInfo.province.find(
          ({ code }) => code === this.regionInfo.provinceCode
        )
          ? this.addressInfo.province.find(
              ({ code }) => code === this.regionInfo.provinceCode
            ).name
          : "";
        console.log("this.regionInfo", this.regionInfo);
      }
    },
    value: {
      deep: true,
      async handler(data) {
        await this.getThreeLevelAddress();
        this.cityDetail = this.addressInfo.city.filter(
          ({ name, code }) => code.slice(0, 2) === data.provinceCode.slice(0, 2)
        );
        this.countyDetail = this.addressInfo.county.filter(
          ({ name, code }) => code.slice(0, 4) === data.cityCode.slice(0, 4)
        );
        console.log("this.cityDetail", this.cityDetail);
        this.regionInfo.cityCode = data.cityCode;
        this.regionInfo.provinceCode = data.provinceCode;
        this.regionInfo.countyCode = data.countyCode;
        this.regionInfo.city = data.city;
        this.regionInfo.province = data.province;
        this.regionInfo.county = data.county;
        console.log("this.regionInfo1", this.regionInfo);
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegionCascade/index.vue